import React from "react";
import { CtaButton } from "../CtaButton";
import { images } from "../../data/content";
export function Author() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-86" data-mp="1ht3o1126fjyo">
      <div className="mx-auto max-w-5xl md:grid md:grid-cols-[2fr_3fr] md:items-center md:gap-10" data-id="element-87" data-mp="1wgf2pbtnnk30">
        <img src={images.author} alt="Dr. Elowen Varelli" className="mx-auto w-full max-w-sm rounded-3xl object-cover shadow-xl md:max-w-none" loading="lazy" data-id="element-88" data-mp="1rq8dpav8dxk8" />
        <div className="mt-8 md:mt-0" data-id="element-89" data-mp="20is7ny0kvdyq">
          <p className="text-sm font-extrabold text-mint-700" data-id="element-90" data-mp="20hqt3jkcs9c9">Created Under the Editorial Identity of</p>
          <h2 className="mt-1 font-display text-4xl font-extrabold text-plum-950" data-id="element-91" data-mp="2ferobx1r6mfh">Dr. Elowen Varelli</h2>
          <p className="mt-1 font-semibold text-plum-600" data-id="element-92" data-mp="2ah7vns4b6740">Pediatric Feeding Therapy Blueprint™ — Professional Resource Collection</p>
          <div className="mt-5 space-y-4 text-base leading-relaxed text-slate-700" data-id="element-93" data-mp="g2ov3v3budom">
            <p data-id="element-94" data-mp="g4rw1a60pr84">
              The Pediatric Feeding Therapy Blueprint™ is presented under the existing editorial identity of Dr. Elowen
              Varelli, consistent with the Pediatric Occupational Therapy resource collection that includes the School
              Sensory Accommodation Blueprint™.
            </p>
            <p data-id="element-95" data-mp="3u5hjsa9hch7p">
              The resource focuses on practical professional organization, structured documentation, individualized
              planning tools, and interdisciplinary coordination. Its purpose is to provide reusable frameworks that
              qualified professionals can adapt to their own clinical settings, responsibilities, and standards of
              practice.
            </p>
            <p className="font-bold text-plum-900" data-id="element-96" data-mp="gzr6zpt5m4h9">
              The objective is simple: make the documentation and planning process more structured, repeatable, and
              practical.
            </p>
          </div>
          <div className="mt-8" data-id="element-97" data-mp="2irnf0pg44w7a">
            <CtaButton label="Get Dr. Varelli’s Blueprint Today" sub="Instant access · $27" data-id="element-98" data-mp="2isost1oijwsp" />
          </div>
        </div>
      </div>
    </section>;
}